<p-chip class="py-0.5 px-1 mb-3 !rounded-full" [style]="{backgroundColor: 'white'}">
    <span class="ml-2 font-lg font-bold ">
        {{ label }}
    </span>
    <span class="bg-primary text-primary-contrast rounded-full h-8 flex items-center justify-center px-3" [style]="style">
        {{ value }}
    </span>
</p-chip>
